import { render, staticRenderFns } from "./promotion-viewer-tag-selector-wrapper.vue?vue&type=template&id=f23621d8&scoped=true"
import script from "./promotion-viewer-tag-selector-wrapper.vue?vue&type=script&lang=js"
export * from "./promotion-viewer-tag-selector-wrapper.vue?vue&type=script&lang=js"
import style0 from "./promotion-viewer-tag-selector-wrapper.vue?vue&type=style&index=0&id=f23621d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23621d8",
  null
  
)

export default component.exports